<template>
    <div style="padding: 10px" >






        <el-row>

            <!--            主体-->
            <el-col>
                <div style="text-align: center;border-bottom:1px dotted #ccc ">
                    <h3 style="padding: 5px 0">{{list.title}}</h3>
                    <span>Time：{{list.addTime}}</span>
                </div>


            </el-col>
            <el-col :offset="4" :span="16">
                <div>
                    <img :src="list.imgpath" alt="" >
                </div>
                <div v-html="list.content"></div>
            </el-col>


        </el-row>

    </div>


</template>

<script>
    import request from "@/utils/request";
    export default {
        name: "Page2",
        props:{
            keyword: String,
        },
        data(){
            return{
                active:false,
                isPC:false,
                show:true,
                position:'',
                total:"",
                currentPage:1,
                keywords:"",
                base:['高级搜索','搜索'],
                types:[
                    {name:"铁氧体磁芯",arr:['EE',"UF"]},

                ],
                list:[],
                catId:'',

                _beforeUnload_time: '',//刷新还是关闭
                _gap_time: '',
                activeItem:''
            }
        },
        methods:{

            addClass(index){

                this.position=index

            },

            toggleShopShow(){
                this.show= !this.show;
            },
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },

            getData(catId){

                sessionStorage.setItem("Page2catId",catId)
                request.get("/mate_management/getOneById/de/"+catId).then(res =>{
                    this.list=res.data

                })
            },


            clickMenu(i,s){



            },
            handleSelect(key, keyPath) {
                this.activeItem=key
            }

        },

        created() {
            if (this._isMobile()) {
                this.isPC = false;
            } else {
                // alert("pc端");
                // this.$router.replace('/test');
                this.isPC = true;
            }
            // alert(sessionStorage.getItem("catId"))
            if (sessionStorage.getItem("Page2catId")!=null){

                request.get("/mate_management/getOneById/de/"+sessionStorage.getItem("Page2catId")).then(res =>{
                    this.list=res.data


                })
            }else {

            }

        }
        ,destroyed() {

        },



    }
</script>

<style scoped>
    .el-row {
        margin-bottom: 20px;

    }
    .el-row:nth-child(3){
        margin-right: 0;
        padding-right: 0;
    }
    .el-col {
        border-radius: 4px;
        margin-top: 40px;
    }


    .active{
        /*border: 2px solid orange !important;*/

        border: 1px solid #000 !important;

    }

    button{

        color: #409EFF;
        float: right;
        padding-right: 10px;
        line-height: 30px;
        cursor: pointer;
        border: none;
        background-color: #ffffff;


    }
    input{
        float: right;
        margin-right: 10px;
        height: 30px !important;
        border-radius:70px ;
    }
    input:hover{
        border:1px solid #cccccc;

    }

    .el-menu {
        border: 0 !important;
        padding-bottom: 10px;


    }

    >>>.el-menu-item{
        color: #409EFF;
    }
    
    .productLi{
        float: left;
        width: 10vw;
        height: 100px;
        border: 1px solid #ccc;
        margin-left: -1px;
    }
    .productLi2{
        float: left;
        width: 25vw;
        height: 100px;
        border: 1px solid #ccc;
        /*margin-left: -1px;*/
    }
    .productLi span,.productLi2 span{
        height: 50px;
        line-height: 50px;
        display: block;
        text-align: center
    }

</style>